import React from 'react'
import { Box, Card, CardMedia, Grid, Typography } from "@mui/material"
import { Game, getUser, isLoser, isWinner } from "model/Game"
import { User } from "model/User"
import { groupBy } from "script/arrayutil"
import { DeckType } from 'model/DeckType'
import { useMediaContext } from 'context/MediaContext'

type Props = {
  user: User,
  games: Game[],
  showDetail: (games: Game[]) => void
}
export default function WinRateByDeckType(props: Props) {
  const { isPc } = useMediaContext()

  const gamesByDeckType =
    groupBy(props.games.slice(), game => getUser(props.user, game).deck_type.id!)
      .sort((a, b) => b[1].length - a[1].length)
      .slice()

  function getWinCount(games: Game[]): number {
    return games.filter(game => isWinner(props.user, game)).length
  }

  function getLoseCount(games: Game[]): number {
    return games.filter(game => isLoser(props.user, game)).length
  }

  function getWinRate(games: Game[]): number {
    const winrate = (
      getWinCount(games) / (getWinCount(games) + getLoseCount(games))
    ) * 100
    return Math.floor(winrate * Math.pow(10, 2)) / Math.pow(10, 2)
  }

  function getDeckTypeName(deckType: DeckType): string {
    if (!deckType.main_theme) return ''
    const mainThemeName = deckType.main_theme.name
    const subThemeName = deckType.sub_theme?.name
    let name = mainThemeName
    if (subThemeName) name += ` + ${subThemeName}`
    return name
  }

  return (
    <Grid container columns={15} rowSpacing={1} sx={{mt: 0.5}}>
      {gamesByDeckType.map(([_, games]) => (      
        <React.Fragment key={games[0].id}>
          <Grid xs={5} md={3} item display='flex'>
            <Card
              onClick={() => props.showDetail(games)}
              sx={{
                width: isPc ? 120 : 90,
                cursor: 'pointer',
                boxShadow: '5px 5px 10px #060606'
              }}
            >
              <CardMedia
                component='img'
                height='70'
                alt=''
                image={getUser(props.user, games[0]).deck_type.thumbnail_url} 
              />
              <Box sx={{pl: 0.5}}>
                <Typography
                  variant={isPc ? 'subtitle1' : 'body2'}
                >
                  {getDeckTypeName(getUser(props.user, games[0]).deck_type)}
                </Typography>
                {isPc &&
                  <Typography
                    variant='body2'
                    color='text.secondary'>
                    戦績
                  </Typography>
                }
                <Typography
                  variant={isPc ? 'body1' : 'body2'}>
                  {getWinCount(games)}-{getLoseCount(games)}
                </Typography>
                {isPc &&
                  <Typography
                    variant='body2'
                    color='text.secondary'>
                    勝率
                  </Typography>
                }
                <Typography
                  variant={isPc ? 'body1' : 'body2'}>
                  {getWinRate(games)}%
                </Typography>
              </Box>
            </Card>
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  )
}